export default __webpack_public_path__ + "static/media/results4.5afba3fa.png";